import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#ACB8C3" d="M87.5 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      d="M42.5 103a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M15.5 70.5H10V65c0-.83-.67-1.5-1.5-1.5S7 64.17 7 65v5.5H1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H7V79c0 .83.67 1.5 1.5 1.5S10 79.83 10 79v-5.5h5.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M108.67 37.95l3.89-3.89c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.89 3.89-3.89-3.89a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.89 3.89-3.89 3.89a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.89-3.89 3.89 3.89c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#ACB8C3"
      d="M12 110c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M95.25 39.02V39s-.01-.08-.01-.12c0-.1-.01-.21-.03-.31-.01-.07-.04-.14-.06-.21l-.06-.21c-.03-.07-.07-.13-.1-.2-.03-.06-.06-.13-.1-.19s-.09-.12-.14-.18c-.04-.05-.08-.11-.13-.16-.07-.07-.16-.14-.24-.2a1 1 0 0 1-.09-.08h-.01v-.01L59.27 13.14c-.77-.53-1.78-.53-2.54 0L21.75 37.13h-.01s-.05.06-.08.08c-.09.07-.17.13-.25.21-.05.05-.09.11-.13.16-.05.06-.1.11-.14.18-.04.06-.07.13-.11.19-.03.06-.07.13-.1.19-.03.07-.05.14-.07.22l-.06.2c-.02.11-.03.21-.03.32 0 .04-.01.07-.01.11v48c0 1.24 1.01 2.25 2.25 2.25h70c1.24 0 2.25-1.01 2.25-2.25V39.01zM58 17.73l27.74 19.02H76.2L59.28 25.14c-.77-.53-1.78-.53-2.54 0L39.82 36.75h-9.54l27.74-19.02zM47.76 36.75 58 29.73l10.24 7.02zm-5.01 4.5h13v43.5h-13zm17.5 0h13v43.5h-13zm-35 0h13v43.5h-13zm65.5 43.5h-13v-43.5h13z"
    />
  </svg>
);
const SvgEnrichedIconFramingGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconFramingGreyscale);
export default Memo;
